import { MapConfigToPayloadArgs } from '../types/event-payload';

/*eslint-disable */

function mapConfigToPayload({
  rawJson,
  eventName,
  eventParams,
  vertical,
  entryPoint,
}: MapConfigToPayloadArgs) {
  const analytics = rawJson.analytics ?? {};
  const geo = analytics.geo ?? {};
  const device = analytics.deviceInfo ?? {};
  const session = analytics.session ?? {};
  const app = analytics.appInfo ?? {};
  const network = analytics.network ?? {};
  const appPerf = analytics.appPerformance ?? {};
  const traffic = analytics.trafficSource ?? {};

  return {
    user_id: rawJson.msisdn ?? '',
    digital_id: analytics.digitalId ?? '',
    mau_id: analytics.mauId ?? '',
    event_timestamp: Math.floor(Date.now() / 1000),
    event_date: new Date().toISOString().split('T')[0],
    event_server_timestamp_offset:
      analytics.eventServerTimestampOffset ?? Math.floor(Date.now() / 1000)?.toString(),
    entry_point: entryPoint ?? 'unknown',
    vertical: vertical ?? 'default',
    connectivity_status: analytics.connectivityStatus || 'unknown',
    event_name: eventName ?? 'unknown_event',
    event_params: eventParams ?? {
      screen: 'unknown',
      extraInfo: '',
      response: { status: '', message: '' },
    },
    session: {
      id: session.id ?? null,
      start_timestamp: session.startTimestamp ?? null,
      ip: session.ip ?? '',
    },
    device_info: {
      id: device.id ?? 0,
      brand: device.brand ?? '',
      operating_system: device.operatingSystem ?? '',
      model: device.model ?? '',
      device_language: device.deviceLanguage ?? '',
      operating_system_version: device.operatingSystemVersion ?? '',
    },
    installation_id: analytics.installationId ?? '',
    app_info: {
      id: app.id ?? '',
      version: app.version ?? '',
      install_store: app.installStore ?? '',
      install_source: app.installSource ?? '',
    },
    traffic_source: {
      name: traffic.name ?? '',
      medium: traffic.medium ?? '',
      source: traffic.source ?? '',
    },
    network: {
      carrier: network.carrier ?? '',
      cellular_generation: network.cellularGeneration ?? 'UNKNOWN',
      mobile_country_code: network.mobileCountryCode ?? '',
      mobile_network_code: network.mobileNetworkCode ?? '',
      network_state_type: network.networkStateType ?? '',
    },
    app_performance: {
      battery_low_power_mode: appPerf.batteryLowPowerMode ?? false,
      battery_percentage: appPerf.batteryPercentage ?? 0,
      battery_state: appPerf.batteryState ?? 'UNKNOWN',
      data_down_kb: appPerf.dataDownKb ?? 0,
      data_up_kb: appPerf.dataUpKb ?? 0,
    },
    geo: {
      country_subdivision: geo.countrySubdivision || ' ',
      city: geo.city || ' ',
      latitude: geo.latitude || 0,
      longitude: geo.longitude || 0,
      country_iso_code: geo.countryIsoCode || ' ',
      continent: geo.continent || ' ',
      country: geo.country || ' ',
      continent_code: geo.continentCode || ' ',
      as: {
        domain: geo.as?.domain || ' ',
        name: geo.as?.name || ' ',
        type: geo.as?.type || ' ',
      },
      location: geo.location || [0, 0],
    },
  };
}

export default mapConfigToPayload;
